import { Component, inject } from '@angular/core';
import { ToastService } from '../core/toast.service';
import { UiTooltip } from './ui-tooltip';

@Component({
  selector: 'app-toast-host',
  imports: [UiTooltip],
  template: `
    <div class="toast-viewport" aria-live="polite" aria-relevant="additions">
      @for (item of toast.items(); track item.id) {
        <article
          class="toast"
          [class.toast-success]="item.kind === 'success'"
          [class.toast-error]="item.kind === 'error'"
          [class.toast-info]="item.kind === 'info'"
          role="status"
        >
          <span class="toast-icon" aria-hidden="true">
            @switch (item.kind) {
              @case ('success') { ✓ }
              @case ('error') { ! }
              @default { i }
            }
          </span>
          <p>{{ item.message }}</p>
          <button type="button" class="toast-close" (click)="toast.dismiss(item.id)" aria-label="Dismiss notification" appTooltip="Dismiss">×</button>
        </article>
      }
    </div>
  `,
})
export class ToastHost {
  readonly toast = inject(ToastService);
}
